<template> 
    <div v-if="is_visible" class="toast" :class="colorClass">
        {{text}}
        <button v-on:click="toggleVisibility" class="close_button" :id="`tracking__${trackingCode}__farm-screen__good-news__close`">&times;</button>
    </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    },
    colorClass: {
      type: String,
      default: "green"
    },
    showToast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_visible: true,
      trackingCode: window.trackingCode
    };
  },
  watch: {
    showToast: {
      handler(val) {
        if (val) {
          this.is_visible = true;
        }
      }
    }
  },
  methods: {
    toggleVisibility: function toggleVisibility() {
      this.is_visible = !this.is_visible;
    }
  },
  created: function() {}
};
</script>